/* eslint-disable no-nested-ternary */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Center from '../../assets/styles/Center';
import EditContainer from '../../assets/styles/EditContainer';
import Text from '../../assets/styles/Text';
import FormAuth from '../../components/FormAuth';
import Loader from '../../components/Loader';
import Title from '../../components/Title';
import ServicesService from '../../services/ServicesService';
import { useStore } from '../../stores';
import * as styles from './styles';

export default function ModelService() {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [services, setServices] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  const { id } = useStore((state) => state.user);

  useEffect(() => {
    async function loadServices() {
      try {
        setLoading(true);

        const servicesService = await ServicesService.listService();

        setServices(servicesService);
      } catch (error) {
        toast.error('Erro ao carregar serviços');
      } finally {
        setLoading(false);
      }
    }

    loadServices();
  }, [id]);

  useEffect(() => {
    async function loadExistingModelServices() {
      if (services.length === 0) return;

      try {
        setLoading(true);

        const existingData = await ServicesService.getModelServices();

        if (existingData && existingData.length > 0) {
          const formattedData = {};

          existingData.forEach((item) => {
            formattedData[item.serviceId] = item.optionType;
          });

          setSelectedValues(formattedData);
        }
      } catch (error) {
        // Silent error handling
        console.log(error);
      } finally {
        setLoading(false);
      }
    }

    loadExistingModelServices();
  }, [services]);

  const handleChange = (serviceId, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [serviceId]: value,
    }));
  };

  const hasValue = (serviceId) => {
    const value = selectedValues[serviceId];
    return value !== undefined && value !== null && value !== '';
  };

  const handleRemove = async (serviceId) => {
    try {
      setSelectedValues((prev) => {
        const newValues = { ...prev };
        delete newValues[serviceId];
        return newValues;
      });

      await ServicesService.deleteModelService(serviceId);

      toast.success('Serviço removido com sucesso!');
    } catch (error) {}
  };

  async function onSubmit() {
    try {
      setSubmitting(true);

      const entries = Object.entries(selectedValues);
      const itemsToUpdate = [];
      const itemsToRemove = [];

      entries.forEach(([serviceId, optionType]) => {
        if (optionType === '' || !optionType || optionType.trim() === '') {
          itemsToRemove.push(serviceId);
        } else {
          itemsToUpdate.push({ serviceId, optionType });
        }
      });

      for (const serviceId of itemsToRemove) {
        await ServicesService.deleteModelService(serviceId);
      }

      if (itemsToUpdate.length > 0) {
        await ServicesService.upsertModelServiceBatch(itemsToUpdate);
      }

      toast.success('Serviços salvos com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar serviços');
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) return <Loader isLoading={loading} />;

  return (
    <EditContainer>
      <Center className="center">
        <Title
          title="Informe seus serviços"
          subtitle="Adicione seus serviços"
        />

        <FormAuth
          buttonTitle={submitting ? 'Salvando...' : 'Continuar'}
          next
          twoButtons
          isLoading={submitting}
          onSubmit={onSubmit}
          formValid={!submitting}
          disabled={submitting}
        >
          <styles.Info>
            <Text.Span $bold>
              Caso nenhuma opção seja marcada o serviço não aparecerá no seu
              perfil
            </Text.Span>
          </styles.Info>

          {services?.map((service) => (
            <styles.GroupInput key={service.id}>
              <label>{service.name}</label>
              <small>{service.description}</small>

              {selectedValues[service.id] && (
                <styles.Selected>
                  <Text.Span>
                    Selecionado:{' '}
                    {selectedValues[service.id] === 'NAO'
                      ? 'Não'
                      : selectedValues[service.id] === 'SIM'
                      ? 'Sim'
                      : 'Sim, com taxa adicional'}
                  </Text.Span>
                </styles.Selected>
              )}

              <styles.Bubble
                htmlFor={`${service.id}-NAO`}
                $checked={selectedValues[service.id] === 'NAO'}
              >
                <input
                  type="radio"
                  id={`${service.id}-NAO`}
                  name={`service-${service.id}`}
                  value="NAO"
                  checked={selectedValues[service.id] === 'NAO'}
                  onChange={() => handleChange(service.id, 'NAO')}
                  hidden
                />
                <Text.Span>Não</Text.Span>
              </styles.Bubble>

              <styles.Bubble
                htmlFor={`${service.id}-SIM`}
                $checked={selectedValues[service.id] === 'SIM'}
              >
                <input
                  type="radio"
                  id={`${service.id}-SIM`}
                  name={`service-${service.id}`}
                  value="SIM"
                  checked={selectedValues[service.id] === 'SIM'}
                  onChange={() => handleChange(service.id, 'SIM')}
                  hidden
                />
                <Text.Span>Sim</Text.Span>
              </styles.Bubble>

              <styles.Bubble
                htmlFor={`${service.id}-COM_TAXA_ADICIONAL`}
                $checked={selectedValues[service.id] === 'COM_TAXA_ADICIONAL'}
              >
                <input
                  type="radio"
                  id={`${service.id}-COM_TAXA_ADICIONAL`}
                  name={`service-${service.id}`}
                  value="COM_TAXA_ADICIONAL"
                  onChange={() =>
                    handleChange(service.id, 'COM_TAXA_ADICIONAL')
                  }
                  hidden
                />
                <Text.Span>Sim, com taxa adicional</Text.Span>
              </styles.Bubble>

              {hasValue(service.id) && (
                <styles.ButtonRemove
                  type="button"
                  onClick={() => handleRemove(service.id)}
                  title="Remover seleção"
                >
                  <Text.Span>Limpar seleção</Text.Span>
                </styles.ButtonRemove>
              )}
            </styles.GroupInput>
          ))}
        </FormAuth>
      </Center>
    </EditContainer>
  );
}
